import React from 'react';
import Watermark from '@tv2/lib-offspring/components/watermark/Watermark';
import { Link } from '../../../../Link';
import { MiniHeroContent } from '../MiniHeroContent';
import { MiniHeroImage } from '../MiniHeroImage';
import { CardProps } from './ContentCard';

export function ContentCardMiniHero({ card, actions }: CardProps): React.ReactNode {
  return (
    <div key={card.id}>
      <Link destination={card.destination} action={card.action} onAction={actions}>
        <div
          className="relative hover:scale-s 2xl:hover:scale-xs transition-transform pb-1"
          {...(card.title ? { 'aria-label': card.title } : {})}
        >
          <div className="relative w-full overflow-hidden">
            <MiniHeroImage
              mobileImageUrl={card.mobileImageUrl}
              tabletImageUrl={card.tabletImageUrl}
              desktopImageUrl={card.desktopImageUrl}
              alt={card.title ?? ''}
            />

            {card.logoUrl ? (
              <Watermark alt={card.title ?? ''} title={card.title ?? ''} src={card.logoUrl} />
            ) : null}

            <MiniHeroContent labels={card.labels} title={card.title} subTitle={card.subTitle} />
          </div>
        </div>
      </Link>
    </div>
  );
}
